// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1zQim","unreadBadge":"styles_unreadBadge__nKzCs","modalContent":"styles_modalContent__1R0ZF","modal":"styles_modal__1nMZz"};